(function () {
  'use strict';

  function getSummary(picker) {
    var renderedSummary = picker.querySelector('[data-custom-dimensions-summary]');
    var renderedText = renderedSummary ? String(renderedSummary.textContent || '').trim() : '';
    if (renderedText && renderedText !== 'Choose dimensions' && renderedText !== 'Choose size' && renderedText !== 'Custom size') {
      return renderedText;
    }

    var fields = Array.prototype.slice.call(picker.querySelectorAll('[data-store-only-property="true"], [data-custom-dimension-field]'));
    var summaryParts = fields.map(function (field) {
      var label = field.getAttribute('data-custom-dimension-field') || '';
      var value = String(field.value || '').trim();
      var match = value.match(/^\d+(?:\.\d+)?/);
      if (!match) return '';
      var val = match[0];
      var norm = label.toLowerCase();
      if (norm === 'diameter') return val + '"Dia.';
      if (norm === 'length') return val + '"L';
      if (norm === 'width') return val + '"W';
      if (norm === 'height') return val + '"H';
      if (norm === 'depth') return val + '"D';
      return val + '"' + label;
    }).filter(Boolean);

    return summaryParts.join(' / ');
  }

  function hasCustomDimensionValue(picker) {
    return Array.prototype.slice.call(picker.querySelectorAll('[data-store-only-property="true"], [data-custom-dimension-field]')).some(function (field) {
      return String(field.value || '').trim() !== '';
    });
  }

  function update() {
    document.querySelectorAll('[data-custom-dimensions-picker]').forEach(function (picker) {
      if (!picker.classList.contains('custom-dimensions-picker--custom-mode') &&
        !picker.classList.contains('custom-dimensions-picker--customize-active')) return;

      var summaryText = getSummary(picker);
      if (!summaryText) return;

      var productInfo = picker.closest('[id^="ProductInfo-"]');
      var sectionId = productInfo ? productInfo.id.replace(/^ProductInfo-/, '') : '';
      if (!sectionId) return;

      document.querySelectorAll('.block_custom-varient[data-section-id="' + sectionId + '"] [data-price-breakdown]').forEach(function (summary) {
        var label = summary.querySelector('.block-price-breakdown__row--base .block-price-breakdown__label');
        if (label) {
          var productTitle = (summary.getAttribute('data-product-title') || '').trim();
          if (!productTitle) {
            var current = String(label.textContent || '').trim();
            var separator = current.lastIndexOf(' - ');
            productTitle = separator === -1 ? current : current.slice(0, separator);
          }
          var nextLabel = productTitle + ' - ' + summaryText;
          if (String(label.textContent || '') !== nextLabel) {
            label.textContent = nextLabel;
          }
        }

        var amount = summary.querySelector('.block-price-breakdown__row--base .block-price-breakdown__amount');
        var total = summary.querySelector('.block-price-breakdown__total-amount');
        if (amount && amount.textContent !== '-') amount.textContent = '-';
        if (total) {
          var hasCustomValue = hasCustomDimensionValue(picker);
          var nextTotal = hasCustomValue ? 'Quote upon request' : '-';
          if (total.textContent !== nextTotal) total.textContent = nextTotal;
          total.classList.toggle('block-price-breakdown__total-amount--quote', hasCustomValue);
        }
      });
    });
  }

  document.addEventListener('input', update, true);
  document.addEventListener('change', update, true);
  document.addEventListener('custom-dimensions:input', update, true);
  document.addEventListener('change', function () {
    setTimeout(update, 0);
    setTimeout(update, 120);
  }, true);
  update();
})();
